import React from 'react';

const marker = (
	<>
		<circle fill="#FF9500" cx="16" cy="16" r="8"/>
		<g strokeWidth="1" transform="translate(12.000000, 12.000000)" fill="#FFFFFF">
			<path
				d="M3.55555556,2.88900317 L2.66666667,2.88900317 L2.66666667,0.000114285714 L1.77777778,0.000114285714 L1.77777778,2.88900317 L0.888888889,2.88900317 L0.888888889,0.000114285714 L0,0.000114285714 L0,2.88900317 C0,3.80106667 0.795555556,4.53979683 1.77777778,4.53979683 L1.77777778,8.25408254 L2.66666667,8.25408254 L2.66666667,4.53979683 C3.64888889,4.53979683 4.44444444,3.80106667 4.44444444,2.88900317 L4.44444444,0.000114285714 L3.55555556,0.000114285714 L3.55555556,2.88900317 Z M5.77777778,1.65090794 L5.77777778,4.95249524 L7.11111111,4.95249524 L7.11111111,8.25408254 L8,8.25408254 L8,0.000114285714 C6.77333333,0.000114285714 5.77777778,0.92455873 5.77777778,1.65090794 L5.77777778,1.65090794 Z"/>
		</g>
	</>
);

const FoodMarkers = () => (
	<g id="foodMarkers" transform="translate(951.000000, 122.000000)">
		<g id="ic-food" transform="translate(160.000000, 829.000000)">{marker}</g>
		<g id="ic-food" transform="translate(704.000000, 1058.000000)">{marker}</g>
		<g id="ic-food" transform="translate(890.000000, 989.000000)">{marker}</g>
		<g id="ic-food" transform="translate(1347.000000, 1054.000000)">{marker}</g>
		<g id="ic-food" transform="translate(1199.000000, 752.000000)">{marker}</g>
		<g id="ic-food" transform="translate(945.000000, 545.000000)">{marker}</g>
		<g id="ic-food" transform="translate(1114.000000, 333.000000)">{marker}</g>
		<g id="ic-food" transform="translate(863.000000, 222.000000)">{marker}</g>
		<g id="ic-food" transform="translate(1343.000000, 0.000000)">{marker}</g>
		<g id="ic-food" transform="translate(1301.000000, 288.000000)">{marker}</g>
		<g id="ic-food" transform="translate(848.000000, 1392.000000)">{marker}</g>
		<g id="ic-food" transform="translate(225.000000, 818.000000)">{marker}</g>
		<g id="ic-food" transform="translate(369.000000, 771.000000)">{marker}</g>
		<g id="ic-food" transform="translate(963.000000, 920.000000)">{marker}</g>
		<g id="ic-food" transform="translate(0.000000, 729.000000)">{marker}</g>
		<g id="ic-food" transform="translate(42.000000, 584.000000)">{marker}</g>
		<g id="ic-food" transform="translate(475.000000, 715.000000)">{marker}</g>
		<g id="ic-food" transform="translate(369.000000, 827.000000)">{marker}</g>
		<g id="ic-food" transform="translate(44.000000, 610.000000)">{marker}</g>
		<g id="ic-food" transform="translate(673.000000, 443.000000)">{marker}</g>
	</g>
);

export default FoodMarkers;
